<div class="flex w-full items-center justify-between gap-5">
  <div class="flex min-h-9 w-full justify-between rounded-2xl bg-neutral-100 px-4 py-1">
    <div class="flex gap-4">
      <ng-content select="[back-link]"></ng-content>
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="flex gap-4">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
